import { marker as bitfToTranslate } from '@biesbjerg/ngx-translate-extract-marker';
export enum EContractStatus {
  OPEN = 'OPEN',
  TAKEN_OVER_CO = 'TAKEN_OVER_CO',
  TAKEN_OVER_DELIVERY_ON_SITE = 'TAKEN_OVER_DELIVERY_ON_SITE',
  TAKEN_OVER_PURCHASING = 'TAKEN_OVER_PURCHASING',
  SUPPLY_TESTING_EM_PARTIAL_OR_TOTAL = 'SUPPLY_TESTING_EM_PARTIAL_OR_TOTAL',
  CLOSED = 'CLOSED',
}

export enum ESpecificContractStatus {
  SUPPLY_TESTING_EM_PARTIAL = 'SUPPLY_TESTING_EM_PARTIAL',
  SUPPLY_TESTING_EM_TOTAL = 'SUPPLY_TESTING_EM_TOTAL',
}

const toTranslate = [
  bitfToTranslate('CONTRACTS.STATUS.OPEN'),
  bitfToTranslate('CONTRACTS.STATUS.TAKEN_OVER_CO'),
  bitfToTranslate('CONTRACTS.STATUS.TAKEN_OVER_DELIVERY_ON_SITE'),
  bitfToTranslate('CONTRACTS.STATUS.TAKEN_OVER_PURCHASING'),
  bitfToTranslate('CONTRACTS.STATUS.SUPPLY_TESTING_EM_PARTIAL_OR_TOTAL'),
  bitfToTranslate('CONTRACTS.STATUS.SUPPLY_TESTING_EM_PARTIAL'),
  bitfToTranslate('CONTRACTS.STATUS.SUPPLY_TESTING_EM_TOTAL'),
];
